exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-info-block {\n  display: flex;\n  margin-right: -15px;\n  margin-left: -15px;\n  padding-top: 0.2rem;\n  padding-bottom: 0.4rem;\n  border-bottom: 1px solid #6d757d;\n}\n.fm-info-block .progress {\n  margin-top: 0.3rem;\n}\n.fm-info-block .text-right > span {\n  padding-left: 0.5rem;\n  cursor: pointer;\n}", ""]);

// exports
